import { SUPPORTED_LANGUAGES } from "@elemt/app-i18n";

export const supportedLngs = SUPPORTED_LANGUAGES;

// This is the language you want to use in case
// the user language is not in the supportedLngs
export const fallbackLng = "en";

// The default namespace of i18next is "translation", but you can customize it
export const defaultNS = "translation";

export type SupportedLanguages = typeof supportedLngs[number];